import script from "./FormPreviewBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./FormPreviewBlock.vue?vue&type=script&setup=true&lang=js"

import "./FormPreviewBlock.vue?vue&type=style&index=0&id=6d0bdece&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/barmm-admin-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d0bdece"]])

export default __exports__